import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as LogoSiberat } from '../../svg/logo.svg';
import ReCAPTCHA from 'react-google-recaptcha';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import sendEmailAPI from '../../features/forgot-password/sendEmail';
import {
  Backdrop,
  CircularProgress,
  InputAdornment,
  OutlinedInput
} from '@mui/material';
import { toast } from 'react-toastify';
import { Icon } from '@iconify/react';
import usePageTitle from '../../hooks/usePageTitle';

const schema = Yup.object().shape({
  email: Yup.string().required('Email is required')
});

const ForgotPassword = () => {
  usePageTitle('Forgot Password');
  const [isCaptcha, setIsCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const setCAPTCHA = () => {
    setIsCaptcha(true);
  };

  const sendEmail = async (data, e) => {
    e.preventDefault();
    if (!isCaptcha) {
      toast.error('Captcha harus diisi');
      return;
    }
    setLoading(true);
    sendEmailAPI(data, setLoading, reset);
    e.stopPropagation();
  };

  return (
    <div className='login-page min-h-screen flex flex-col'>
      <header className='mb-[35px]'>
        <div className='flex justify-between px-5 pt-5'>
          <div className='my-auto w-[50px] md:w-[75px]'>
            <LogoSiberat />
          </div>
        </div>
      </header>

      <Backdrop
        sx={theme => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>

      <section className='flex items-center justify-center container mx-auto mt-6 md:mt-auto content-center flex-1'>
        <div
          id='image-login'
          className='hidden md:flex flex-initial w-1/2 items-center justify-end pr-4 lg:pr-8'>
          <img
            src='/images/img-forgot-multimodal.png'
            alt='Pengiriman alat berat via kapal dan truck'
            className='auth-hero-img object-contain'
          />
        </div>

        <div id='form-login' className='flex-initial m-auto p-5 max-w-[440px] w-full'>
          <div id='title' className='flex flex-col'>
            <h1 className='text-[32px] md:text-[35px] font-bold text-[#1B2124] leading-tight m-0'>
              Forgot password
            </h1>
          </div>
          <p
            id='desc'
            className='text-left text-sm my-3 font-normal text-[#6B7280]'>
            Enter the email linked to your account and we’ll send a reset link.
          </p>

          <form onSubmit={handleSubmit(sendEmail)} className='text-sm'>
            <label
              className='font-medium block mb-1.5 mt-6 text-[#4F4F4F]'
              htmlFor='email'>
              Email
            </label>
            <OutlinedInput
              id='email'
              name='email'
              {...register('email')}
              className={`input-login w-full ${
                errors.email ? 'border-red-500' : ''
              }`}
              autoFocus
              placeholder='you@company.com'
              required
              type='email'
              size='small'
              startAdornment={
                <InputAdornment position='start'>
                  <Icon
                    icon='solar:letter-bold'
                    width={18}
                    color='#888888'
                  />
                </InputAdornment>
              }
            />
            {errors.email && (
              <p className='text-red-500 text-xs italic mt-1'>
                {errors.email.message}
              </p>
            )}

            <ReCAPTCHA
              className='mt-4 mb-4'
              onChange={setCAPTCHA}
              sitekey='6LdmPYwrAAAAAA-ysuar4K6qi_LU4exFo8-Kp91X'
            />

            <button
              type='submit'
              className='btn-primary-siberat w-full h-12 py-3 px-4 focus:outline-none'>
              Send reset link
            </button>
          </form>

          <div className='text-sm mt-5'>
            <NavLink
              to='/login'
              className='inline-flex items-center gap-1.5 text-[#6B7280] font-medium'>
              <Icon icon='solar:arrow-left-bold' width={16} />
              Back to sign in
            </NavLink>
          </div>
        </div>
      </section>

      <footer className='mt-auto px-5 py-5'>
        <div className='font-medium text-xs text-[#9CA3AF]'>
          &copy; {new Date().getFullYear()} PT. SiBerat Digital Logistik, All
          Rights Reserved.
        </div>
      </footer>
    </div>
  );
};

export default ForgotPassword;
